import { render, staticRenderFns } from "./HowToGameMode.vue?vue&type=template&id=0d0378d8&scoped=true&"
import script from "./HowToGameMode.vue?vue&type=script&lang=ts&"
export * from "./HowToGameMode.vue?vue&type=script&lang=ts&"
import style0 from "./HowToGameMode.vue?vue&type=style&index=0&id=0d0378d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0378d8",
  null
  
)

export default component.exports